export const CONTAINER_SPACING_TOP = '50%';
export const CONTAINER_SPACING_TOP_DESKTOP = '5%';
